












































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';
import { Field } from '@/model';
import { SelectResult, Doc, Facets } from '@service/solr/collections';

const Store = namespace('discover');

@Component
export default class Discover extends Vue {
  private localQueryString = '';

  @State
  private collections!: string[];

  @Store.State private fields!: Field[];
  @Store.State private selectedFields!: Field[];
  @Store.State private availableFields!: Field[];
  @Store.State private queryString!: string;
  @Store.State private loadingMore!: boolean;
  @Store.State private loadingFields!: boolean;
  @Store.State private fieldsStats!: Facets;
  @Store.State private loadingFieldsStats!: boolean;
  @Store.State private numHit!: number;
  @Store.State private docs!: Doc[];

  @Store.Mutation private setCollection!: (collection: string) => void;
  @Store.Mutation private setQueryString!: (queryString: string) => void;
  @Store.Mutation private setResult!: (result: SelectResult) => void;
  @Store.Mutation private setDocs!: (docs: Doc[]) => void;
  @Store.Mutation private setAvailableFields!: (fields: Field[]) => void;
  @Store.Mutation private setSelectedFields!: (fields: Field[]) => void;
  @Store.Mutation private addSelectedField!: (field: Field) => void;
  @Store.Mutation private removeSelectedField!: (field: Field) => void;

  @Store.Action private loadMore!: () => void;
  @Store.Action private loadFieldsStats!: () => void;
  @Store.Action private loadFields!: () => void;

  mounted() {
    this.localQueryString = this.queryString === '*:*' ? '' : this.queryString;
    if (!this.collection) {
      this.selectCollection();
    }
  }

  get collection(): string {
    return this.$store.state.discover.collection;
  }

  set collection(value: string) {
    this.setCollection(value);
  }

  selectCollection() {
    const lastCollection = localStorage.getItem('collection');
    if (lastCollection && this.collections.includes(lastCollection)) {
      this.setCollection(lastCollection);
    } else if (this.collections.length > 0) {
      this.setCollection(this.collections[0]);
    }
  }

  onQuery() {
    if (this.loadingMore) return;
    this.setQueryString(this.localQueryString || '*:*');
    this.setResult({} as SelectResult);
    this.setDocs([]);
    this.loadMore();
    this.loadFieldsStats();
  }

  sourceFormatter(row: Doc) {
    return this.fields
      .filter((f) => row[f.name as keyof Doc])
      .map((f) => `${f.name}: ${row[f.name as keyof Doc]}`)
      .join(' ');
  }

  @Watch('collections')
  onCollectionsChanged() {
    this.selectCollection();
  }

  @Watch('collection', { immediate: true })
  onCollectionChanged() {
    this.setResult({} as SelectResult);
    this.setDocs([]);
    this.loadFields();
    this.loadMore();
  }

  @Watch('fields')
  onFieldsChanged() {
    this.setAvailableFields(Array(...this.fields));
    this.setSelectedFields([]);
    this.loadFieldsStats();
  }
}
